const LanguageCodes = ['cs', 'de', 'el', 'en', 'es', 'fr', 'hr', 'it', 'nl', 'pl', 'pt', 'ro', 'ru', 'sk', 'sl', 'sr', 'tr', 'zh'];
module.exports = LanguageCodes;